import(/* webpackMode: "eager" */ "/var/www/InfinityV1/app/partner/page.tsx");
